import {combineReducers, Reducer} from 'redux';
import {communicationReducer} from 'UserProfile/store/contactRequest/reducer/communications';
import {IContactRequestState} from 'UserProfile/store/contactRequest/types';

export const contactRequestReducer: Reducer<IContactRequestState> = combineReducers<IContactRequestState>({
  communications: communicationReducer
});
